const UserType = require( '../enums/UserType');
const DocumentRuleEnums = require( '../enums/DocumentRule');

const CognitoUser = {
    attributes:{
        name: '',
        family_name:'',
        birthdate:'',
        email:'',
        phone_number:'',
        address:''
    },
    username:''
}

const DocumentGroup = {
        name: '',
        type: '',
        applyTo: '',
        documentRules: new Map()
}

const DocumentRule = {
        name: '',
        required: false,
        expiredInterval: DocumentRuleEnums.DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE,
        approvalRequired: false,
        notificationInterval: DocumentRuleEnums.DOCUMENT_RULE_CONFIGURATIONS.NOTIFICATION.DEFAULT_VALUE,
        requiredLogHours: false,
        type: '',
        status: DocumentRuleEnums.DOCUMENT_RULE_STATUS.ACTIVE
}

const Employee = {
        name: '',
        cognitoUsername: '',
        cognitoEmailVerified:'',
        documentGroup: new Map(),
        documentFiles: {},
        status: '',
        clients: new Map(),
        geoPoint:{}
}

const EmployeeType = {
        name: '',
        documentGroups: new Map(),
        type: UserType.USER_TYPE.EMPLOYEE
}

const ClientType = {
        name: '',
        documentGroups: new Map(),
        reportGroups: new Map(),
        type: UserType.USER_TYPE.CLIENT
}

const Client = {
        name:'',
        guardian_name:'',
        guardian_phone_number: '',
        guardian_email: '',
        address: '',
        geoPoint:{},
        birthdate: '',
        family_name: '',
        documentFiles: {},
        documentGroups: [],
        status:''
}

const AuthorizationRule = {
        name:'',
        documentRuleId: '',
        documentRuleName: '',
        employeeGroupTypes:[]
}

const AuthorizationRecord = {
        authorizationName: '',
        authorizationRuleId:'',
        clientId:'',
        documentRuleId:'',
        documentFileId:'',
        employeeGroupTypeHrs:{},
        totalHrs : {},
        startDate:'',
        endDate:'',
        timePeriod: '',
        status: '',
}

const EmbeddedClientAuthorization = {
        authorizationRecordId:'',
        documentFileId: '',
        startDate: '',
        endDate: '',
        timePeriod:'',
        status:''
}

const EmployeeClientReport = {
        employeeId: '',
        clientId: '',
        clientName: '',
        employeeName: '',
        status: '',
        requiredLogHours: '',
        documentFile:{}
}

export {
        CognitoUser,
        DocumentGroup,
        DocumentRule,
        Employee,
        Client,
        EmployeeType,
        ClientType,
        AuthorizationRule,
        AuthorizationRecord,
        EmbeddedClientAuthorization,
        EmployeeClientReport
};